export default __webpack_public_path__ + "static/media/30.706100c4.png";